<template>
    <v-container
        class="fill-height"
        fluid
    >
        <!-- style="min-height: 434px" -->
        <v-row align="start">
            <v-img
                src="../assets/logo-monitor.png"
                :max-height="showButton ? 400 : 200"
                contain
                
            ></v-img>
        </v-row>
        <v-row justify="center" align="start">
            <v-btn
                color="primary"
                dark
                x-large
                @click="triggerDialog()"
                v-if="showButton"
            >
                {{ loginButtonLabel }}
            </v-btn>
            <amplify-authenticator
                v-if="showDialog"
            ></amplify-authenticator>
        </v-row>
    </v-container>
</template>

<script>

import { Hub } from 'aws-amplify';
import '@aws-amplify/ui-vue';
import { text } from '@/language';

export default {
    name: 'NotSignedInView',

    created() {
        this.globalState = this.$root.$data.globalState;

        Hub.listen( 'auth', data => {
            if ( data.payload.event === 'signIn' ) {
                this.$router.push( '/' );
            }
        } );
    },

    components: {
    },

    computed: {
    },

    data: () => ({
        globalState : {},
        loginButtonLabel : text( 'notSignedInViewButtonLabel' ),
        showButton: true,
        showDialog : false,
    }),

    methods : {
        triggerDialog() {
            this.showDialog = true;
            this.showButton = false;
        },
    },
};
</script>
